import { render } from "./GoodsSearch.vue?vue&type=template&id=f9363a3e&scoped=true"
import script from "./GoodsSearch.vue?vue&type=script&lang=js"
export * from "./GoodsSearch.vue?vue&type=script&lang=js"

import "./GoodsSearch.vue?vue&type=style&index=0&id=f9363a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9363a3e"]])

export default __exports__